import { put, select, takeLatest } from 'redux-saga/effects'
import { getSignersSelector } from '../selectors'
import { setSignerList } from '../store/completeChart.actions'
import { CompleteChartConstants } from '../store/completeChart.constants'
import { ISignerState } from '../store/completeChart.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setPin() {
  const signerState: ISignerState = yield select(getSignersSelector)
  const { pin, signer, signerList } = signerState
  const selectedPin = signerList.filter((u) => u.key === signer?.key)
  if (selectedPin && selectedPin.length) {
    selectedPin[0].pin = pin
    yield put(setSignerList(signerList))
  }
}
export function* setPinSaga() {
  yield takeLatest([CompleteChartConstants.SET_PIN], performWithMutexHOG, setPin)
}
